import { FaAccessibleIcon, FaGg } from "react-icons/fa";
import { SiDatabricks } from "react-icons/si"
import { MdConnectWithoutContact } from "react-icons/md";

export const featureList = [
    {
        id: 1,
        icon: <FaAccessibleIcon color="#0a1930" size={22} />,
        heading: 'Designed for you',
        text: "BaiSocialX is made to enhance the user experience of social media and to get rightfully rewarded for contributing by posting photos and video in return for cryptocurrency."

    },

    {
        id: 2,
        icon: <SiDatabricks color="#0a1930" size={22} />,
        heading: 'Keep Your History',
        text: "Sky is the limit when it comes to the possibilities of BaiSocialX. The platform offers a space where creativity and originality is recognized, appreciated and rewarded."

    },

    {
        id: 3,
        icon: <MdConnectWithoutContact color="#0a1930" size={22} />,
        heading: 'Stay Connected',
        text: "In a world that is constantly changing, BaiSocialX works together with a great team of developers to deliver you an innovative platform with a unique philosophy."

    },

    {
        id: 4,
        icon: <FaGg color="#0a1930" size={22} />,
        heading: 'Take Control',
        text: "BaiSocialX aspires to become a new global leader in social media with its unique cryptocurrency reward mechanism and ecosystem."

    },

    
]